import { getStats } from "../../api/fleet";
import { useAsync } from "../../hooks/useAsync";

/**
 * Kiro-Go 舰队统计看板,对应 design.md > 前端页面设计 `FleetStatsPage.tsx`
 * (Requirements 9.1-9.6):总数、按状态分布、按区域分布、7 天内到期数量、
 * 月度成本估算。
 */
export function FleetStatsPage() {
  const stats = useAsync(() => getStats(), []);

  return (
    <div>
      <h2 className="section-title">Kiro-Go 舰队统计</h2>

      {stats.loading && <p>加载中...</p>}
      {stats.error && <div className="error-banner">{stats.error}</div>}

      {stats.data && (
        <div className="card-grid">
          <div className="card" data-testid="stat-total">
            <div style={{ fontSize: 12, color: "#64748b" }}>实例总数</div>
            <div style={{ fontSize: 28, fontWeight: 700 }}>{stats.data.total}</div>
          </div>

          <div className="card" data-testid="stat-by-status">
            <div style={{ fontSize: 12, color: "#64748b", marginBottom: 8 }}>按部署状态分布</div>
            {Object.entries(stats.data.by_status).map(([status, count]) => (
              <div key={status} style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{status}</span>
                <strong>{count}</strong>
              </div>
            ))}
          </div>

          <div className="card" data-testid="stat-by-region">
            <div style={{ fontSize: 12, color: "#64748b", marginBottom: 8 }}>按部署区域分布</div>
            {Object.entries(stats.data.by_region).map(([region, count]) => (
              <div key={region} style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{region}</span>
                <strong>{count}</strong>
              </div>
            ))}
          </div>

          <div className="card" data-testid="stat-expiring-soon">
            <div style={{ fontSize: 12, color: "#64748b" }}>7 天内到期(READY)</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: "#d97706" }}>{stats.data.expiring_soon_7d}</div>
          </div>

          <div className="card" data-testid="stat-monthly-cost">
            <div style={{ fontSize: 12, color: "#64748b" }}>月度成本估算(USD)</div>
            <div style={{ fontSize: 28, fontWeight: 700, color: "#059669" }}>${stats.data.monthly_cost_usd}</div>
          </div>
        </div>
      )}
    </div>
  );
}
